import { Injectable } from '@angular/core';
import { PscHttpService } from '../../services/psc-http.service';
import { AuthService } from '../../services/auth/auth.service';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserCheckStartupService {

  constructor(
    private httpService: PscHttpService,
    private authService: AuthService,
  ) {
  }

  load() {
    if (!this.authService.getToken()) {
      return false;
    }

    return this.authService.userCheck().pipe(
      catchError(
        (error) => {
          if (error.status === 401) {
            this.authService.tokenExpired();
          }

          return of();
        },
      ),
    );
  }
}
